// Module
var code = `<div class="modal-dialog" role="document">
    <div class="modal-content" tabindex="-1">
        <div class="modal-header">
            <div class="flex-horizontal">
                <div class="flex-grow">
                    <h3 id="myModalLabel" data-bind="text: op.title, attr:{ class: 'modal-title ' + op.headerClass() }"></h3>
                </div>
                <div class="flex-grow text-right margin-right margin-right-sm">
                    <span class="text-muted">Time elapsed:</span> <span data-bind="text: op.duration"></span>
                </div>
                <div>
                    <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                        <i class="icon-cancel"></i>
                    </button>
                </div>
            </div>
            <div class="notification-time" data-bind="text: op.displayDate().format('LLL')"></div>
        </div>
        <div class="modal-body">
            <div class="modal-details" data-bind="visible: progress">
                <div class="details-item" data-bind="with: progress">
                    <div class="row">
                        <div class="col-sm-6 text-right">Items Processed:</div>
                        <div class="col-sm-6 details-value" data-bind="text: Total.toLocaleString()"></div>
                    </div>
                </div>
                <div class="details-item">
                    <div class="row">
                        <div class="col-sm-6 text-right">Processing Speed:</div>
                        <div class="col-sm-6 details-value" data-bind="text: \$root.processingSpeed"></div>
                    </div>
                </div>
                <div class="details-item" data-bind="with: progress">
                    <div class="row">
                        <div class="col-sm-6 text-right"> Batch count: </div>
                        <div class="col-sm-6 details-value" data-bind="text: BatchCount.toLocaleString()"></div>
                    </div>
                </div>
                <div class="details-item" data-bind="with: progress">
                    <div class="row">
                        <div class="col-sm-6 text-right">Last processed document ID</div>
                        <div class="col-sm-6 details-value" data-bind="text: LastProcessedId"></div>
                    </div>
                </div>
            </div>
            <div data-bind="with: result">
                <h3 data-bind="text: Message"></h3>
            </div>
            <div data-bind="if: operationFailed">
                <h3 class="text-danger text-center">Operation failed!</h3>
                <pre class="margin-top error-messages"><code data-bind="foreach: errorMessages"><span data-bind="text: \$data"></span>
</code></pre>
            </div>
        </div>
        <div class="modal-footer" data-bind="compose: \$root.footerPartialView">
        </div>
    </div>
</div>
`;
// Exports
export default code;